import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { CompetitionsService } from '../../../core/competitions/competitions';

@Component({
  selector: 'app-competition-new',
  imports: [ReactiveFormsModule, RouterLink],
  templateUrl: './competition-new.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './competition-new.css',
})
export class CompetitionNew {
  private readonly competitions = inject(CompetitionsService);
  private readonly router = inject(Router);

  readonly submitting = signal(false);
  readonly errorMessage = signal<string | null>(null);

  readonly form = new FormGroup({
    name: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.maxLength(100)],
    }),
    startDate: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    endDate: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    submissionEndDate: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });

  async submit(): Promise<void> {
    if (this.form.invalid || this.submitting()) {
      this.form.markAllAsTouched();
      return;
    }

    this.submitting.set(true);
    this.errorMessage.set(null);
    try {
      const created = await this.competitions.create(this.form.getRawValue());
      await this.router.navigateByUrl(`/competitions/${created.id}`);
    } catch (err) {
      this.errorMessage.set(
        err instanceof HttpErrorResponse && err.status === 409
          ? "That date range overlaps with one of your existing competitions, or your plan's active-competition limit is already reached."
          : err instanceof HttpErrorResponse && err.status === 400
            ? 'Check that the end date is after the start date, and the submission cutoff falls within them.'
            : 'Something went wrong on our end — give it another try in a moment.',
      );
    } finally {
      this.submitting.set(false);
    }
  }
}
